import useNetwork from './network';
import { ISoftwareModel } from './models/softwareModel';

const getManagingSoftwares = async (lng: string) => {
    const { fetchSoftware } = useNetwork();
    const result = await fetchSoftware(lng);

    if (result.status === 200) {
        return (await result.json()) as ISoftwareModel[];
    }
};

export default getManagingSoftwares;
